import { faLock } from "@fortawesome/free-solid-svg-icons";

import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3TextInput from "../../core/et3-input/et3-text-input";
import getCoreLoginStore from "../../stores/core/core-login-store";

const PasswordFormItem = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitX, unitY } = theme;
  const { isSignInDisabled, password, setPassword, signIn } =
    getCoreLoginStore();
  const disabledEnter = isSignInDisabled.get();

  return (
    <Et3TextInput
      size="MEDIUM"
      withShadow={true}
      icon={faLock}
      type={"password"}
      label={i18n.get("PASSWORD")}
      placeHolder={i18n.get("PASSWORD")}
      value={password.get()}
      onChoose={(value: string) => setPassword(value)}
      onBlur={() => {}}
      style={{
        width: 280 * unitX,
        height: 95 * unitY
      }}
      onEnter={() => {
        if (!disabledEnter) signIn();
      }}
    />
  );
});
export default PasswordFormItem;
